import { GridView, ViewList } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
import { ColorModeContext, theme } from 'app/Theme';
import { useContext } from 'react';

export default function ChangeView({ view, setView }) {
    const { mode } = useContext(ColorModeContext);
    const toggleView = () => {
        const newView = view === 'listView' ? 'gridView' : 'listView';
        setView(newView);
    };

    const tooltipText =
        view === 'listView' ? 'Switch to Grid View' : 'Switch to List View';
    const Icon = view === 'listView' ? GridView : ViewList;

    return (
        <Box>
            <Tooltip title={tooltipText} placement='top'>
                <IconButton color={mode === 'light' ? theme.palette.secondary.main : theme.palette.primary.main} onClick={toggleView}>
                    <Icon />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
